import { NavLink, useNavigate } from 'react-router-dom';
import '../styles/sidebar.css';
import { useEffect, useState } from 'react';

export default function Sidebar() {
  const navigate = useNavigate();
      const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const checkMobile = () => {
        setIsMobile(window.innerWidth < 1100);
      };
      checkMobile();
      window.addEventListener('resize', checkMobile);
      
      return () => window.removeEventListener('resize', checkMobile);
    }, []);

  let roles = localStorage.getItem("roles");
  roles = roles ? JSON.parse(roles) : [];

  const isTerminalOfficer = roles.some(
    (role) =>
      role.role_name === "Terminal Officer" ||
      role.role_name === "Admin"
  );  console.log("roles===",roles)

  const isAdmin = roles.some(
    (role) =>
      role.role_name === "Admin"
  );  console.log("roles===",roles)

  const isClient = roles.some(
    (role) =>
      role.role_name === "Terminal Client"
  );  console.log("roles===",roles)

  let path = "";

if (isAdmin || isTerminalOfficer) {
  path = "/family-office";
} 
else if (isClient) {
  const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("user_name");
  path = `/client-holdings?id=${userId}&name=${userName}`;

}

const handleLogout = () => {
  const confirmed = window.confirm("Are you sure you want to logout?");
  if (!confirmed) return; 

  localStorage.clear();
  // navigate("/login", { replace: true });
  window.location.replace('https://www.pricingculture.com/collectible-assets-terminal')
};

  return (
    <aside className="sidebar">      
      <nav className='main-nav'>
      <div style={!isMobile?{display:'flex',flexDirection:'column',justifyContent:'space-between',height:'85vh'}:{}}>
        <div style={isMobile?{display:'flex',flexDirection:'row',justifyContent:'space-between',gap:10}:{}}>
          <div className="nav-section">
            <div className="section">MAIN</div>
            <div className="nav-group">
            {isAdmin&&(<NavLink to="/orgs" className="nav-link">
                <span className="icon">🕋</span>
                <span className="label">Orgs</span>
              </NavLink>)}
              {isTerminalOfficer&&(<NavLink 
              // to="/family-office" 
              to ="/family-dashboard"
              className="nav-link">
                <span className="icon">🏠</span>
                <span className="label">Dashboard</span>
              </NavLink>)}
              
              <NavLink to={path} className="nav-link">
                <span className="icon">💼</span>
                <span className="label">Client Accounts</span>
              </NavLink>
              
              {/* <NavLink to="/indications" className="nav-link">
                <span className="icon">💡</span>
                <span className="label">Indications</span>
              </NavLink> */}
            </div>
          </div>

          <div className="nav-section">
            <div className="section">RESEARCH</div>
            <div className="nav-group">
              <NavLink to="/news" className="nav-link">
                <span className="icon">📰</span>
                <span className="label">News</span>
              </NavLink>
              
              <NavLink to="/insights" className="nav-link">
                <span className="icon">💭</span>
                <span className="label">Intelligence</span>
              </NavLink>
              
              <NavLink to="/indices" className="nav-link">
                <span className="icon">📊</span>
                <span className="label">Indices</span>
              </NavLink>
            </div>
          </div>
        </div>

        {!isMobile&&(<div className="nav-section">
          <div className="nav-group">
            <div onClick={handleLogout} className="nav-link" style={{cursor: 'pointer'}}>
              <span className="icon">
                <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 2C10.2386 2 8 4.23858 8 7C8 7.55228 8.44772 8 9 8C9.55228 8 10 7.55228 10 7C10 5.34315 11.3431 4 13 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 19.7614 10.2386 22 13 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H13Z" fill="#fff"/>
                <path d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11.2821C11.1931 13.1098 11.1078 13.2163 11.0271 13.318C10.7816 13.6277 10.5738 13.8996 10.427 14.0945C10.3536 14.1921 10.2952 14.2705 10.255 14.3251L10.2084 14.3884L10.1959 14.4055L10.1915 14.4115C10.1914 14.4116 10.191 14.4122 11 15L10.1915 14.4115C9.86687 14.8583 9.96541 15.4844 10.4122 15.809C10.859 16.1336 11.4843 16.0346 11.809 15.5879L11.8118 15.584L11.822 15.57L11.8638 15.5132C11.9007 15.4632 11.9553 15.3897 12.0247 15.2975C12.1637 15.113 12.3612 14.8546 12.5942 14.5606C13.0655 13.9663 13.6623 13.2519 14.2071 12.7071L14.9142 12L14.2071 11.2929C13.6623 10.7481 13.0655 10.0337 12.5942 9.43937C12.3612 9.14542 12.1637 8.88702 12.0247 8.7025C11.9553 8.61033 11.9007 8.53682 11.8638 8.48679L11.822 8.43002L11.8118 8.41602L11.8095 8.41281C11.4848 7.96606 10.859 7.86637 10.4122 8.19098C9.96541 8.51561 9.86636 9.14098 10.191 9.58778L11 9C10.191 9.58778 10.1909 9.58773 10.191 9.58778L10.1925 9.58985L10.1959 9.59454L10.2084 9.61162L10.255 9.67492C10.2952 9.72946 10.3536 9.80795 10.427 9.90549C10.5738 10.1004 10.7816 10.3723 11.0271 10.682C11.1078 10.7837 11.1931 10.8902 11.2821 11H3Z" fill="#fff"/>
                </svg>

              </span>
              <span className="label">Logout</span>
            </div>
            
            
          </div>
        </div>)}
      </div>

      {/* <div style={{position: 'absolute', bottom: '20px',marginLeft:'20px', cursor: 'pointer'}} onClick={() => {
        handleLogout()
      }}>
          <div style={{fontSize: '12px', color: '#888', textAlign: 'center', marginBottom: '10px'}}>
              <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 2C10.2386 2 8 4.23858 8 7C8 7.55228 8.44772 8 9 8C9.55228 8 10 7.55228 10 7C10 5.34315 11.3431 4 13 4H17C18.6569 4 20 5.34315 20 7V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17C10 16.4477 9.55228 16 9 16C8.44772 16 8 16.4477 8 17C8 19.7614 10.2386 22 13 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H13Z" fill="#fff"/>
              <path d="M3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11.2821C11.1931 13.1098 11.1078 13.2163 11.0271 13.318C10.7816 13.6277 10.5738 13.8996 10.427 14.0945C10.3536 14.1921 10.2952 14.2705 10.255 14.3251L10.2084 14.3884L10.1959 14.4055L10.1915 14.4115C10.1914 14.4116 10.191 14.4122 11 15L10.1915 14.4115C9.86687 14.8583 9.96541 15.4844 10.4122 15.809C10.859 16.1336 11.4843 16.0346 11.809 15.5879L11.8118 15.584L11.822 15.57L11.8638 15.5132C11.9007 15.4632 11.9553 15.3897 12.0247 15.2975C12.1637 15.113 12.3612 14.8546 12.5942 14.5606C13.0655 13.9663 13.6623 13.2519 14.2071 12.7071L14.9142 12L14.2071 11.2929C13.6623 10.7481 13.0655 10.0337 12.5942 9.43937C12.3612 9.14542 12.1637 8.88702 12.0247 8.7025C11.9553 8.61033 11.9007 8.53682 11.8638 8.48679L11.822 8.43002L11.8118 8.41602L11.8095 8.41281C11.4848 7.96606 10.859 7.86637 10.4122 8.19098C9.96541 8.51561 9.86636 9.14098 10.191 9.58778L11 9C10.191 9.58778 10.1909 9.58773 10.191 9.58778L10.1925 9.58985L10.1959 9.59454L10.2084 9.61162L10.255 9.67492C10.2952 9.72946 10.3536 9.80795 10.427 9.90549C10.5738 10.1004 10.7816 10.3723 11.0271 10.682C11.1078 10.7837 11.1931 10.8902 11.2821 11H3Z" fill="#fff"/>
              </svg>
              <span style={{fontSize:14,marginLeft:10}}>Logout</span>            
          </div>
        </div> */}
      </nav>
    </aside>
  );
}